/**
 * Cadena de carga del menú público (orden fijo — no reordenar sin actualizar tests y docs).
 *
 * @see docs/MENU_FALLBACK_CHAIN_SOLUQR.md
 */

/** Tier 1: API principal (Vercel proxy → Railway). */
export const MENU_PRIMARY_API_PREFIX = '/menu';

/** Tier 2: menu-public-api (Render). */
export const MENU_PUBLIC_API_BASE = (
  process.env.REACT_APP_MENU_PUBLIC_API_URL || 'https://menu.soluqr.cl'
).replace(/\/$/, '');

/** Tier 3: snapshots estáticos en el bundle (checkout deshabilitado). */
export const STATIC_MENU_SNAPSHOT_PATHS = [
  (slug) => `/menu-cache/${encodeURIComponent(slug)}.json`,
  (slug) => `/fallback-menus/${encodeURIComponent(slug)}.json`,
];

export const MENU_FALLBACK_SOURCES = {
  PRIMARY_API: 'primary_api',
  MENU_PUBLIC_API: 'menu_public_api',
  STATIC_SNAPSHOT: 'static_snapshot',
};

/**
 * @typedef {'primary_api'|'menu_public_api'|'static_snapshot'|null} MenuFallbackTierId
 */

/**
 * @param {import('@/lib/menuPublicSnapshot').MenuPublicSnapshot|null|undefined} snapshot
 * @returns {MenuFallbackTierId}
 */
export function detectMenuFallbackTier(snapshot) {
  if (!snapshot) return null;
  const source = snapshot.fallback_source;
  if (source === 'menu_public_api') return MENU_FALLBACK_SOURCES.MENU_PUBLIC_API;
  if (typeof source === 'string' && source.includes('.json')) {
    return MENU_FALLBACK_SOURCES.STATIC_SNAPSHOT;
  }
  if (snapshot.fallback_mode) return MENU_FALLBACK_SOURCES.STATIC_SNAPSHOT;
  return MENU_FALLBACK_SOURCES.PRIMARY_API;
}

export function buildMenuPublicApiUrl(slug) {
  const safe = String(slug || '').trim().toLowerCase();
  if (!safe) return null;
  return `${MENU_PUBLIC_API_BASE}/menu/${encodeURIComponent(safe)}`;
}

export function staticMenuSnapshotUrls(slug) {
  const safe = String(slug || '').trim().toLowerCase();
  if (!safe) return [];
  return STATIC_MENU_SNAPSHOT_PATHS.map((fn) => fn(safe));
}
